import style from "assets/jss/material-dashboard-pro-react/views/createWireTransferStyle.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { withArtifex } from "core";
import DateHelper from "core/DateHelper";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { GenericDateInput, GenericNumberInput, GenericSelectInput, GenericTextInput } from "views/Components/Generic";

class OrderingAmountDetail extends Component {
   constructor(props) {
      super(props);
      this.MaxLen = { maxLength: 60 };
   }

   render() {
      const {
         Disabled,
         AmountPrefix,
         ValueChanged,
         WireTransactionDate,
         Amount,
         CurrencyId,
         WireReferenceNumber,
         WirePurpose,
      } = this.props;
      return (
         <GridItem>
            <h4 style={{ color: "black", textAlign: "center" }}>
               <b>Incoming Transfer Detail</b>
            </h4>
            <GridContainer>
               <GridItem xs={6}>
                  <GenericDateInput
                     Name="WireTransactionDate"
                     LabelText="Wire Transaction Date"
                     Value={WireTransactionDate}
                     ValueChanged={ValueChanged}
                     MaxDate={DateHelper.GetDateLocal()}
                     Disabled={false}
							Required
                  />
               </GridItem>
               <GridItem xs={6} />
               <GridItem xs={6}>
                  <GenericNumberInput
                     Name="Amount"
                     LabelText="Amount"
                     Value={Amount}
                     ValueChanged={ValueChanged}
                     Disabled={Disabled}
                     Prefix={AmountPrefix}
							Required
                     MaxLength={10}
                  />
               </GridItem>
               <GridItem xs={6}>
                  <GenericSelectInput
                     Disabled={true}
                     Name="CurrencyId"
                     LabelText="Currency"
                     Value={CurrencyId || "CAD"}
                     KeyValueMember="Id"
                     TextValueMember="Description"
                     Method="GET"
                     Url="/bankapi/v1.0/Currency/ValidCurrencies"
                     DefaultIndex={0}
                     RenderItem={d => d.Code + " - " + d.Description}
                     ValueChanged={ValueChanged}
                     DataRoot="Item"
                  />
               </GridItem>
               <GridItem xs={6}>
                  <GenericTextInput
                     Name="WireReferenceNumber"
                     LabelText="Wire Reference Number"
                     Value={WireReferenceNumber}
                     ValueChanged={ValueChanged}
                     Disabled={Disabled}
                     inputProps={{ maxLength: 60 }} 
                  />
               </GridItem>
               <GridItem xs={6}>
                  <GenericTextInput
                     Name="WirePurpose"
                     LabelText="Purpose Of Wire"
                     Value={WirePurpose}
                     ValueChanged={ValueChanged}
                     Disabled={Disabled}
							Required
                     inputProps={{ maxLength: 256 }}
                  />
               </GridItem>
            </GridContainer>
         </GridItem>
      );
   }
}

OrderingAmountDetail.propTypes = {
   classes: PropTypes.object.isRequired,
   Disabled: PropTypes.bool,
   ValueChanged: PropTypes.func,
   Amount: PropTypes.number,
   AmountPrefix: PropTypes.string,
   WireReferenceNumber: PropTypes.string,
   WirePurpose: PropTypes.string,
   CurrencyId: PropTypes.number,
   WireTransactionDate: PropTypes.any,
};

export default withArtifex(OrderingAmountDetail, style);